import { DialogWithForm } from '@strata/react-dialog';
import { TextInputFormik } from '@strata/react-inputs';
import { validationStrings } from '@strata/strata-ui-strings';
import { Formik } from 'formik';
import { useEffect, useState } from 'react';
import * as Yup from 'yup';

import { handleError } from 'services/Error';
import { useAppDispatch, useAppSelector } from 'store';
import { resetTreatmentSearchData } from 'store/treatments/treatmentListSlice';
import { checkRestrictedGroup } from 'store/treatments/treatmentListThunks';

export const AdditionalSearchInfoDialog = () => {
    const dispatch = useAppDispatch();
    const { restrictedAccess } = useAppSelector((state) => state.auth);
    const { lastSearchParams, searchResults } = useAppSelector((state) => state.treatmentList);

    const [isOpen, setIsOpen] = useState(false);
    useEffect(() => {
        if (
            !restrictedAccess &&
            searchResults?.treatments?.length === 0 &&
            searchResults?.restrictedGroup == null
        ) {
            // eslint-disable-next-line react-hooks/set-state-in-effect
            setIsOpen(true);
        }
    }, [restrictedAccess, searchResults]);

    return (
        <Formik
            initialValues={{ groupId: undefined }}
            validationSchema={Yup.object({
                groupId: Yup.string().required(validationStrings.requiredField.errorMessage),
            })}
            onSubmit={async ({ groupId }, { resetForm }) => {
                try {
                    await dispatch(checkRestrictedGroup({ ...lastSearchParams, groupId }));
                    resetForm();
                    setIsOpen(false);
                } catch (err) {
                    handleError('An error occurred checking group ID.', err as Error);
                }
            }}
        >
            {(formik) => (
                <DialogWithForm
                    dialogTitle="Additional Information Needed"
                    isOpen={isOpen}
                    primaryButtonLabel="Search"
                    isPrimaryButtonDisabled={
                        !(formik.isValid && formik.dirty) || formik.isSubmitting
                    }
                    secondaryButtonLabel="Cancel"
                    onSecondaryButtonClick={(e) => {
                        dispatch(resetTreatmentSearchData());
                        setIsOpen(false);
                        formik.handleReset(e);
                    }}
                    dialogContent={
                        <TextInputFormik id="groupId" label="Member Group ID" required />
                    }
                />
            )}
        </Formik>
    );
};
